<template>
	<div class="file-upload">
		<div class="tools">
			<div class="label grey-text text-darken-2" style="margin-bottom: 4px;" v-bind:class="commentFiles.length > 0 ? 'active' : ''">
				<slot></slot>
			</div>
			<div class="attachments">
					<div class="af" v-for="(x) in existingFiles" :key="x.id">
					<div class="chip left">
					<!-- 	<i class="material-icons action left">article</i> -->
						<a :href="x.url" _target="blank" v-html="x.title"></a>
						<i class="action material-icons grey-text darken-1">delete</i>
					</div>
				</div>
			<div class="clear"></div>
			<div class="divider" style="margin: 12px 0px"></div>
			</div>
			<div class="attachments">
				<div class="af" v-for="(upload,f) in commentFiles" v-bind:key="f * 1.132">
					<div class="chip left">
						<i @click="$_remove(f)" class="material-icons">close</i>
						<span>{{upload.data.name}}</span>
					</div>
				</div>
				<div class="clear"></div>
			</div>
			<div class="file-field left">
				<div class="btn rounded left z-depth-0 uload_button white-text" style="width:200px">
					<span>
						<i class="material-icons white-text text-darken-3 left">attach_file</i> Add Files
					</span>
					<input
						@change="$_triggerSingleUpload()"
						ref="uload"
						id="fu"
						:multiple="isMultiple"
						type="file"
						accept=".jpg, .png, .pdf, .docx"
					/>
				</div>
				<div class="file-path-wrapper" style="opacity:0; z-index:-1; height:0px; overflow:hidden">
					<input class="file-path validate" type="text" />
				</div>
			</div>
			<div class="clear"></div>
		</div>
	</div>
</template>
<script>
import core from "@/functions";
export default {
	name: "fileUpload",
	props: {
		dataContent: {
			type: Object,
		},
		isMultiple: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			dataTest: [],
			commentFiles: new Array()
		};
	},	
	computed: {
		existingFiles: {
			get () {
				let check = this.dataContent.values && this.dataContent.values.length > 0 ? true : false
				return check ? this.dataContent.values : []
			}
		}
	},
	methods: {
		$_triggerSingleUpload() {
			const $_testTypes = type => {
				const allowedTypes = [
					"application/pdf",
					"image/png",
					"image/jpeg",
					"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
					"xls",
					"csv"
				];
				const record = allowedTypes.findIndex(v => v === type);
				record < 0 ? core.toastMessage("File type not allowed", null) : false;
				return record > -1 ? true : false;
			};

			let files = this.$refs.uload.files;
			Array.from(new Set(files)).forEach(file => {
				if ($_testTypes(file.type)) {
					let reader = new FileReader();
					/* eslint-disable-next-line */
					reader.onload = function(e) {
						/* console.log(e) */
					};
					reader.readAsDataURL(file);
					this.commentFiles.push({
						data: file
          });
          this.$emit('files', this.commentFiles)
				}
			});
		},
		$_remove(f) {
      this.commentFiles.splice(f, 1);
      this.$emit('files', this.commentFiles)
		}
	}
};
</script>
<style scoped lang="scss">
.file-upload {
	margin: 0 2px;
	border: 1px solid #dfdfdf;
	border-radius: 5px;
	padding: 13px;
	margin-bottom: 24px;
}
.label {
	transition: all linear 100ms;
	transform: translateY(0px);
	&.active {
		transform: translateY(-25px);
		background: white;
		display: inline-block;
		transition: all linear 100ms;
	}
}
.chip {
	i {
		cursor: pointer !important;
		float: right !important;
		font-size: 16px !important;
		line-height: 32px !important;
		padding-left: 8px !important;
	}
}
</style>